<template>
  <div
    class="view view_Kunden"
    v-if="doRender"
  >
    <viewTabsTop v-if="tabs.length > 1" :tabs="tabs" />
    <!-- CONTENT -->
    <v-container
      v-if="offline"
    >
      <v-alert
        dense transition="scale-transition"
        type="error"
        class="ma-2"
        style="font-size:80%;"
      >
        <b>KEINE NETZWERKVERBINDUNG</b>
        <br>
        Die angezeigten Daten können veraltet sein.
        Bevor Änderungen vorgenommen werden, vergewissern Sie sich, dass die Daten aktuell sind.
      </v-alert>
    </v-container>
    <v-container v-else-if="syncProblem">
      <v-alert
        dense transition="scale-transition"
        type="warning"
        class="ma-2"
        style="font-size:80%;"
      >
        <b>Synchronisierung verzögert</b>
        <br>
        {{ syncProblem }} Die zuletzt geladenen Daten bleiben sichtbar.
      </v-alert>
    </v-container>
    <v-progress-linear
      indeterminate
      v-if="loading"
      absolute
    ></v-progress-linear>
    <transition
      v-if="
        currentTab.code === ''
        && tabs.filter((o) => o.erlaubt === 'x|410|000').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Kundenliste
        v-if="save.xtime"
        :prop_settings="save.settings"
        :prop_kunden="save.kunden"
        :prop_auftraege="save.auftraege"
        :prop_kosten="save.kosten"
        @tryGetOrSave="tryGetOrSave($event)"
      />
    </transition>
    <transition
      v-else-if="
        currentTab.code === '100'
        && tabs.filter((o) => o.erlaubt === 'x|410|000').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Auftraege
        v-if="save.xtime"
        :prop_settings="save.settings"
        :prop_auftraege="save.auftraege"
        :prop_kunden="save.kunden"
        :prop_kosten="save.kosten"
        :prop_activeSaveRequest="activeSaveRequest"
        @tryGetOrSave="tryGetOrSave($event)"
      />
    </transition>
    <transition
      v-else-if="
        currentTab.code === '200'
        && tabs.filter((o) => o.erlaubt === 'x|410|000').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Kostenaufstellung
        v-if="save.xtime"
        :prop_settings="save.settings"
        :prop_kosten="save.kosten"
        :prop_kunden="save.kunden"
        :prop_auftraege="save.auftraege"
        @tryGetOrSave="tryGetOrSave($event)"
      />
    </transition>
    <transition
      v-else-if="
        currentTab.code === 'set'
        && tabs.filter((o) => o.erlaubt === 'x|410|set').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Einstellungen
        v-if="save.xtime"
        :prop_settings="save.settings"
        @tryGetOrSave="tryGetOrSave($event)"
      />
    </transition>
    <p v-else>
      Zugriff verweigert
    </p>
    <!-- CONTENT -->
    <viewTabsBottom v-if="tabs.length > 1" :tabs="tabs" />
  </div>
</template>

<script>
import 'animate.css';
import $ from 'jquery';
import ViewTabsTop from '@/components/ViewTabsTop.vue';
import ViewTabsBottom from '@/components/ViewTabsBottom.vue';
import Einstellungen from '@/components/Funktionen/400/410-Kunden/Einstellungen.vue';
import Kundenliste from '@/components/Funktionen/400/410-Kunden/Kundenliste.vue';
import Auftraege from '@/components/Funktionen/400/410-Kunden/Auftraege.vue';
import Kostenaufstellung from '@/components/Funktionen/400/410-Kunden/Kostenaufstellung.vue';

export default ({
  name: 'Kinder',
  components: {
    ViewTabsTop,
    ViewTabsBottom,
    Einstellungen,
    Kundenliste,
    Auftraege,
    Kostenaufstellung,
  },
  data: () => ({
    loading: false,
    offline: typeof navigator !== 'undefined' && navigator.onLine === false,
    syncProblem: '',
    activeRequest: null,
    activeSaveRequest: null,
    save: {},
    doRender: false,
    tabs: [],
    mytabs: [
      {
        icon: 'mdi-human-child',
        title: 'Kunden',
        route: '/410',
        erlaubt: 'x|410|000',
      },
      {
        icon: 'mdi-file-alert-outline',
        title: 'Aufträge',
        route: '/410-100',
        erlaubt: 'x|410|000',
      },
      {
        icon: 'mdi-cash-multiple',
        title: 'Kosten',
        route: '/410-200',
        erlaubt: 'x|410|000',
      },
      {
        icon: 'mdi-tune',
        title: 'Einstellungen',
        route: '/410-set',
        erlaubt: 'x|410|set',
      },
    ],
    currentTab: {
      code: '',
      query: {},
    },
  }),
  computed: {
    transitionIn() {
      let result = '';
      if (this.$vuetify.breakpoint.mdAndDown) {
        result = 'animate__animated animate__fadeInLeft';
      }
      return result;
    },
    transitionOut() {
      let result = '';
      if (this.$vuetify.breakpoint.mdAndDown) {
        result = 'animate__animated animate__fadeOutLeft';
      }
      return result;
    },
  },
  methods: {
    restoreCachedData() {
      try {
        if (this.save.xtime) {
          return;
        }
        const cachedValue = localStorage.getItem('f410');
        if (!cachedValue) {
          return;
        }
        const cachedData = JSON.parse(cachedValue);
        if (cachedData.save) {
          this.save = cachedData.save;
        }
      } catch (error) {
        // Der Browser-Cache ist optional; Laden und Speichern funktionieren auch ohne ihn.
      }
    },
    tryGetOrSave(dataToSave) {
      this.restoreCachedData();
      const isSaving = Boolean(dataToSave);
      if (this.activeRequest && !isSaving) {
        return;
      }
      if (this.activeRequest && isSaving) {
        if (this.activeSaveRequest) {
          return;
        }
        this.activeRequest.abort();
      }
      if (isSaving) {
        let targetId = null;
        if (dataToSave.data && typeof dataToSave.data === 'object') {
          targetId = dataToSave.data.id || null;
        } else if (dataToSave.data) {
          targetId = dataToSave.data;
        }
        this.activeSaveRequest = {
          type: dataToSave.type,
          targetId,
        };
        this.$store.commit('main/switchIsSaving', true);
      }
      const requestTimeout = isSaving ? 60000 : 30000;
      // Der bestaetigte Stand darf spaetere Eingaben im offenen Dialog nicht ersetzen.
      const gesendeteDaten = isSaving ? JSON.parse(JSON.stringify(dataToSave)) : null;
      this.loading = true;
      const request = $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/400/410/?getSettings`,
        type: 'post',
        dataType: 'json',
        data: {
          code: this.$store.state.login.session.code,
          dataToSave: isSaving ? JSON.stringify(gesendeteDaten) : undefined,
        },
        success: (response) => {
          try {
            if (response && response.status === 'accessError') {
              this.$store.commit('login/backendErrorSession');
            } else if (response && response.status === 'forbidden') {
              this.syncProblem = response.message || 'Für diese Aktion fehlt die Berechtigung.';
              if (isSaving) {
                this.$store.commit('main/alert', {
                  typ: 'warning',
                  text: this.syncProblem,
                }, { root: true });
              }
            } else if (response && response.status === 'error') {
              this.syncProblem = response.message || 'Die Änderung konnte nicht gespeichert werden.';
              if (isSaving) {
                this.$store.commit('main/alert', {
                  typ: 'error',
                  text: this.syncProblem,
                }, { root: true });
              }
            } else if (
              !response
              || !response.save
              || !response.save.settings
              || !Array.isArray(response.save.kunden)
              || !Array.isArray(response.save.auftraege)
              || !Array.isArray(response.save.kosten)
            ) {
              this.syncProblem = 'Der Server hat unvollständige Daten geliefert.';
              if (isSaving) {
                this.$store.commit('main/alert', {
                  typ: 'error',
                  text: `Die Änderung konnte nicht bestätigt werden.
                  Die Eingaben bleiben erhalten; bitte erneut versuchen.`,
                }, { root: true });
              }
            } else {
              this.offline = typeof navigator !== 'undefined' && navigator.onLine === false;
              this.syncProblem = '';
              this.save = {
                xtime: response.save.xtime,
                settings: response.save.settings,
                kunden: response.save.kunden,
                auftraege: response.save.auftraege,
                kosten: response.save.kosten,
              };
              try {
                let help = {
                  save: {},
                };
                if (localStorage.getItem('f410')) {
                  help = JSON.parse(localStorage.getItem('f410'));
                }
                help.save = this.save;
                if (response.save.settings.dataOffline === true) {
                  localStorage.setItem('f410', JSON.stringify(help));
                } else {
                  localStorage.removeItem('f410');
                }
              } catch (error) {
                // Der Browser-Cache ist optional; die Serverdaten bleiben maßgeblich.
              }
              if (isSaving) {
                switch (dataToSave.type) {
                  case 'addKunde':
                    this.save.settings.lastAddedKunde = response.lastAddedKunde;
                    break;
                  case 'delKunde':
                    this.save.settings.lastDeletedKunde = response.lastDeletedKunde;
                    break;
                  case 'saveKunde':
                    this.save.settings.lastEditedKunde = response.lastEditedKunde;
                    break;
                  case 'addAuftrag':
                    this.save.settings.lastAddedAuftrag = response.lastAddedAuftrag;
                    break;
                  case 'duplicateAuftrag':
                    this.save.settings.lastAddedAuftrag = response.lastAddedAuftrag;
                    break;
                  case 'delAuftrag':
                    this.save.settings.lastDeletedAuftrag = response.lastDeletedAuftrag;
                    break;
                  case 'saveAuftrag':
                    this.save.settings.lastEditedAuftrag = response.lastEditedAuftrag;
                    this.$set(this.save.settings, 'lastEditedAuftragErgebnis', {
                      gesendet: gesendeteDaten.data,
                      auftrag: response.save.auftraege.find(
                        (auftrag) => String(auftrag.id) === String(response.lastEditedAuftrag),
                      ),
                    });
                    this.save.settings
                      .lastEditedLeistungenNeuKosten = response.lastEditedLeistungenNeuKosten;
                    break;
                  case 'addKosten':
                    this.save.settings.lastAddedKosten = response.lastAddedKosten;
                    break;
                  case 'duplicateKosten':
                    this.save.settings.lastAddedKosten = response.lastAddedKosten;
                    break;
                  case 'delKosten':
                    this.save.settings.lastDeletedKosten = response.lastDeletedKosten;
                    break;
                  case 'saveKosten':
                    this.save.settings.lastEditedKosten = response.lastEditedKosten;
                    break;
                  default:
                    break;
                }
              }
            }
          } catch (error) {
            this.syncProblem = 'Die Serverdaten konnten nicht verarbeitet werden.';
            if (isSaving) {
              this.$store.commit('main/alert', {
                typ: 'error',
                text: `Die Änderung konnte nicht bestätigt werden.
                Die Eingaben bleiben erhalten; bitte erneut versuchen.`,
              }, { root: true });
            }
          }
        },
        timeout: requestTimeout,
        error: (xhr, textStatus) => {
          if (textStatus === 'abort') {
            return;
          }
          const browserIsOffline = typeof navigator !== 'undefined'
            && navigator.onLine === false;
          this.offline = browserIsOffline;
          if (!browserIsOffline) {
            this.syncProblem = 'Der Server konnte gerade nicht erreicht werden.';
            if (textStatus === 'timeout') {
              this.syncProblem = `Der Server hat nicht innerhalb von ${requestTimeout / 1000} Sekunden geantwortet.`;
            } else if (xhr.status >= 500) {
              this.syncProblem = 'Der Server hat einen Fehler gemeldet.';
            }
          }
          if (isSaving) {
            let message = `Die Änderung konnte nicht bestätigt werden.
              Die Eingaben bleiben erhalten; bitte erneut versuchen,
              sobald die Synchronisierung wieder möglich ist.`;
            if (textStatus === 'parsererror') {
              message = `Die Serverantwort konnte nicht verarbeitet werden.
                Die Eingaben bleiben erhalten; bitte erneut versuchen.`;
            }
            this.$store.commit('main/alert', {
              typ: 'error',
              text: message,
            }, { root: true });
          }
        },
        complete: () => {
          if (this.activeRequest === request) {
            this.activeRequest = null;
            this.loading = false;
            if (isSaving) {
              this.activeSaveRequest = null;
              this.$store.commit('main/switchIsSaving', false);
            }
          }
        },
      });
      this.activeRequest = request;
    },
    handleOffline() {
      this.offline = true;
    },
    handleOnline() {
      const shouldRefresh = this.offline || Boolean(this.syncProblem);
      this.offline = false;
      if (shouldRefresh) {
        this.tryGetOrSave();
      }
    },
    setCurrentTab(route) {
      this.currentTab.code = route.path.replace(this.$router.history.current.path.substring(0, 4), '').replace('-', '');
      this.currentTab.query = route.query;
      this.doRender = true;
    },
  },
  created() {
    window.addEventListener('offline', this.handleOffline);
    window.addEventListener('online', this.handleOnline);
    if (!JSON.parse(localStorage.getItem('f400-410-filterKst'))) {
      localStorage.setItem('f400-410-filterKst', JSON.stringify([]));
    }
    this.tryGetOrSave();
    if (this.$store.state.main.save.mainmenu_links
      .some((e) => e.route === this.$router.history.current.path.substring(0, 4))) {
      // Wenn Zugriff auf diese View erlaubt
      // erlaube das Rendern
      this.setCurrentTab(this.$router.history.current);
    } else {
      // Wenn Zugriff auf diese View NICHT erlaubt
      // Leite zur ersten erlaubten Seite um
      this.$router.push({ path: this.$store.state.main.save.mainmenu_links[0].route });
      localStorage.removeItem('f410');
      window.location.reload();
    }
    // Tabs erstellen:
    this.mytabs.forEach((tab) => {
      if (
        this.$store.state.main.save.user.rechte.find((element) => {
          let bool = false;
          if (element.includes(tab.erlaubt)) {
            bool = true;
          }
          return bool;
        })
      ) {
        this.tabs.push(tab);
      }
    });
    // Wenn der aktuelle Tabs nicht erlaubt ist, zum ersten erlaubten Tab navigieren:
    if (
      this.tabs.filter((o) => o.route === this.$router.history.current.path).length <= 0
      && this.tabs.length > 0
    ) {
      this.$router.push({ path: this.tabs[0].route });
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.setCurrentTab(to);
    next();
  },
  beforeDestroy() {
    window.removeEventListener('offline', this.handleOffline);
    window.removeEventListener('online', this.handleOnline);
    if (this.activeRequest) {
      this.activeRequest.abort();
    }
  },
});
</script>

<style>
</style>
